import 'NS.js';

/**
 * @typedef {Function} glMethod
 * @property {Function} parentMethod
 * @property {string} methodName
 */
var glMethod;

GLOBAL.NS = function(name) {
    var nsList = name.split(".");
    var nsType;
    var ns = "";
    nsList.unshift("GLOBAL");

    for (var i = 0; i < nsList.length; i++) {
        if (ns != "") {
            ns += ".";
        }

        ns += nsList[i];

        eval("nsType = typeof(" + ns + ");");

        if (nsType != "object") {
            eval(ns + " = {};");
        }
    }
};

GLOBAL.Class = function(...parents) {
    // actual instance constructor
    const instance = function(...args) {
        for (let property in instance.prototype) {
            if (instance.prototype.hasOwnProperty(property)) {
                if (typeof instance.prototype[property] != "function") {
                    defineProperty(this, instance.prototype, property);
                }
            }
        }

        this.Parent = noop();
        this.ParentCall = noop();
        this.ParentMethod = noop();
        this.Call = noop();
        this.CallMethod = classCallMethod();
        this.Is = function __classIs__(classObject) {
            return this.Class.Is(classObject);
        };

        this.Class = instance;

        if (this.initialize && typeof(this.initialize) == "function") {
            this.initialize(...args);
        } else {
            for (let i = parents.length; i > 0; i--) {
                if (typeof parents[i - 1] == "function" &&
                    parents[i - 1].prototype.initialize && parents[i - 1].prototype.initialize == "function") {
                    parents[i - 1].prototype.initialize(...args);
                    break;
                }
            }
        }
    };

    // clone properties from parents to the intance prototype
    for (let i = 0; i < parents.length; i++) {
        let parent = parents[i];

        if (typeof(parents[i]) == "function") {
            for (let member in parent.prototype) {
                if (parent.prototype.hasOwnProperty(member)) {
                    defineProperty(instance.prototype, parent.prototype, member);

                    if (typeof instance.prototype[member] == "function") {
                        instance.prototype[member].methodName = member;
                    }
                }
            }

            for (let member in parent) {
                if (parent.hasOwnProperty(member)) {
                    defineProperty(instance, parent, member);

                    if (typeof instance[member] == "function") {
                        instance[member].methodName = member;
                    }
                }
            }
        } else if (typeof parents[i] == "object") {
            for (let member in parent) {
                if (parent.hasOwnProperty(member)) {
                    defineProperty(instance.prototype, parent, member);

                    if (typeof instance.prototype[member] == "function") {
                        instance.prototype[member].methodName = member;
                    }
                }
            }
        } else {
            console.log("Illegal parent", parents[i]);
        }
    }

    // setup methods to call parent's methods
    // todo wrap not wrapped methods with mock inherited methods! issue with calling this.ParentCall in not inherited method
    for (let method in instance.prototype) {
        let methodFound = false;

        if (instance.prototype.hasOwnProperty(method)) {
            if (typeof instance.prototype[method] == "function") {
                for (let i = parents.length; i > 0; i--) {
                    if (typeof parents[i - 1] == "function") {
                        let parent = parents[i - 1];

                        if (parent.prototype.hasOwnProperty(method)) {
                            if (!methodFound) {
                                methodFound = true;
                            } else {
                                if (typeof parent.prototype[method] == "function") {
                                    instance.prototype[method].parentMethod = parent.prototype[method];
                                    instance.prototype[method] = classWrapMethod(instance.prototype[method]);
                                }
                                break;
                            }
                        }
                    } else if (typeof parents[i - 1] == "object") {
                        let struct = parents[i - 1];

                        if (struct.hasOwnProperty(method)) {
                            if (!methodFound) {
                                methodFound = true;
                            } else {
                                if (typeof struct[method] == "function") {
                                    instance.prototype[method].parentMethod = struct[method];
                                    instance.prototype[method] = classWrapMethod(instance.prototype[method]);
                                }
                                break;
                            }
                        }
                    }
                }
            }
        }
    }

    // set parents constructors
    instance.Parents = [];

    for (let i = 0; i < parents.length - 1; i++) {
        let parent = parents[i];

        if (parent.Parents) {
            for (let k = 0; k < parent.Parents.length; k++) {
                let parentParent = parent.Parents[k];

                if (instance.Parents.indexOf(parentParent) == -1) {
                    instance.Parents.push(parentParent);
                }
            }
        }

        if (instance.Parents.indexOf(parent) == -1) {
            instance.Parents.push(parent);
        }
    }

    // add method to create instance's static methods
    instance.Static = function(members) {
        if (members) {
            for (let member in members) {
                if (members.hasOwnProperty(member)) {
                    let methodFound = false;

                    defineProperty(instance, members, member);

                    if (typeof(instance[member]) == "function") {
                        instance[member].methodName = member;

                        for (let i = parents.length - 1; i > 0; i--) {
                            if (typeof(parents[i - 1]) == "function") {
                                let parent = parents[i - 1];

                                if (parent.hasOwnProperty(member) && typeof parent[member] == "function") {
                                    instance[member].parentMethod = parent[member];
                                    instance[member] = classWrapMethod(instance[member]);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }

        if (typeof instance.initialize == "function") {
            instance.initialize();
        }

        return this;
    };

    instance.Static.instance = instance;

    instance.Parent = noop();
    instance.ParentCall = noop();
    instance.ParentMethod = noop();
    instance.Call = noop();
    instance.CallMethod = classCallMethod();
    instance.Is = classIs();

    if (typeof instance.initialize == "function") {
        instance.initialize();
    }

    return instance;
};

/**
 * @param {T} object
 * @param {T} classObject
 * @returns {boolean}
 */
GLOBAL.Class.Is = function(object, classObject) {
    if (!classObject) {
        return false;
    }

    if (!object || typeof object != "object" && typeof object != "function") {
        return false;
    }

    if (object.Is) {
        return object.Is(classObject);
    }

    return false;
};

/**
 * @param {Array.<(Function|Object)>} parents
 * @returns {Object}
 */
GLOBAL.Static = function(...parents) {
    const struct = {};

    for (let i = 0; i < parents.length; i++) {
        let item = parents[i];

        for (let member in item) {
            if (item.hasOwnProperty(member)) {
                defineProperty(struct, item, member);

                if (typeof struct[member] == "function") {
                    struct[member].methodName = member;
                }
            }
        }
    }

    for (let method in struct) {
        let methodFound = false;

        if (struct.hasOwnProperty(method)) {
            if (typeof struct[method] == "function") {
                for (let i = parents.length; i > 0; i--) {
                    if (typeof parents[i - 1] == "function") {
                        let parent = parents[i - 1];

                        if (parent.hasOwnProperty(method)) {
                            if (!methodFound) {
                                methodFound = true;
                            } else {
                                if (typeof parent[method] == "function") {
                                    struct[method].parentMethod = parent[method];
                                    struct[method] = classWrapMethod(struct[method]);
                                }
                                break;
                            }
                        }
                    } else if (typeof parents[i - 1] == "object") {
                        let parent = parents[i - 1];

                        if (parent.hasOwnProperty(method)) {
                            if (!methodFound) {
                                methodFound = true;
                            } else {
                                if (typeof parent[method] == "function") {
                                    struct[method].parentMethod = parent[method];
                                    struct[method] = classWrapMethod(struct[method]);
                                }
                                break;
                            }
                        }
                    }
                }
            }
        }
    }

    struct.Parents = [];

    for (let i = 0; i < parents.length - 1; i++) {
        let parent = parents[i];

        if (parent.Parents) {
            for (let k = 0; k < parent.Parents.length; k++) {
                let parentParent = parent.Parents[k];

                if (struct.Parents.indexOf(parentParent) == -1) {
                    struct.Parents.push(parentParent);
                }
            }
        }

        if (struct.Parents.indexOf(parent) == -1) {
            struct.Parents.push(parent);
        }
    }

    struct.Parent = noop();
    struct.ParentCall = noop();
    struct.ParentMethod = noop();
    struct.Call = noop();
    struct.CallMethod = classCallMethod();
    struct.Is = classIs();

    if (typeof struct.initialize == "function") {
        struct.initialize();
    }

    return struct;
};

/**
 * Clones property of `source` object into `dest` object.
 *
 * @param {Object} dest
 * @param {Object} source
 * @param {string} property
 */
function defineProperty(dest, source, property) {
    const descriptor = Object.getOwnPropertyDescriptor(source, property);

    if (!descriptor.get && !descriptor.set) {
        descriptor.value = clone(source[property]);
    }

    Object.defineProperty(dest, property, descriptor);
}

function clone(object, options) {
    if (typeof options != "object") {
        options = {};
    }

    options.circular = options.circular === undefined ? true : options.circular;

    if (!object || typeof object != "object") {
        return object;
    }

    const result = typeof object.pop == "function" ? [] : {};

    if (!options.replaces) {
        options.replaces = {
            except: [],
            replace: []
        }
    }

    options.replaces.except.push(object);
    options.replaces.replace.push(result);

    for (let key in object) {
        if (object.hasOwnProperty(key)) {
            let value = object[key];

            if (value && typeof value == "object") {
                let idx = options.replaces.except.indexOf(value);

                if (idx != -1) {
                    if (options.circular) {
                        result[key] = options.replaces.replace[idx];
                    }
                } else {
                    result[key] = clone(value, options);
                }
            } else {
                result[key] = value;
            }
        }
    }

    return result;
}

/**
 * Creates instanceof function for multi inheritance
 *
 * @returns {Function}
 */
function classIs() {
    return function __classIs__(classObject) {
        if (!classObject) {
            return false;
        }

        return this == classObject || this.Parents.indexOf(classObject) != -1;
    };
}

/**
 * @returns {Function}
 */
function classCallMethod() {
    return function __classCallMethod__(method, ...args) {
        if (method) {
            return method.apply(this, args);
        }
    };
}

/**
 * Creates function that calls parent method of `func` with it's arguments.
 *
 * @param {glMethod} func
 * @returns {Function}
 */
function classParent(func) {
    return function __classParent__() {
        return func.parentMethod.apply(this, arguments);
    };
}

/**
 * Creates function that calls parent method of `func` with `args` as arguments.
 *
 * @param {glMethod} func
 * @param {Array} args
 * @returns {Function}
 */
function classParentCall(func, args) {
    return function __classParentCall__() {
        return func.parentMethod.apply(this, args);
    };
}

/**
 * Creates function that returns reference to parent method of `func`.
 *
 * @param {glMethod} func
 * @returns {Function}
 */
function classParentMethod(func) {
    return function __classParentMethod__() {
        return func.parentMethod;
    };
}

/**
 * Creates function that calls method with name equal `func.methodName` on class `className`.
 *
 * @param {glMethod} func
 * @returns {Function}
 */
function classCall(func) {
    return function __classCall__(className, ...args) {
        var result;
        args = args.slice();
        eval("result = " + className + ".prototype." + func.methodName + ".apply(this, args);");

        return result;
    };
}

/**
 * Wraps method to support calling to parent's methods
 *
 * @param {glMethod} func
 * @returns {Function}
 */
function classWrapMethod(func) {
    return function __method__(...args) {
        const parent = this.Parent;
        const parentCall = this.ParentCall;
        const parentMethod = this.ParentMethod;
        const call = this.Call;

        this.Parent = classParent(func);
        this.ParentCall = classParentCall(func, args);
        this.ParentMethod = classParentMethod(func);
        this.Call = classCall(func);

        try {
            return func.apply(this, args);
        } finally {
            this.Parent = parent;
            this.ParentCall = parentCall;
            this.ParentMethod = parentMethod;
            this.Call = call;
        }
    };
}

/**
 * @returns {Function}
 */
function noop() {
    return function __noop__() {};
}
